import EventEmitter from "events";
//const WebSocket = require('ws');

class ConnectionManager extends EventEmitter {
  static connections = new Map();
  constructor(endpoint) {
    console.log("constructing connection manager");
    super();
    this.packetParser = null;
    this.endpoint = endpoint;
    this.connections = ConnectionManager.connections;
  }

  setPacketParser(parser) {
    this.packetParser = parser;

    //emit job is to trigger named events
    if (this.packetParser) {
      this.packetParser.on("protocolSwitch", (message) => {
        this.emit("protocolSwitch", message);
      });

      this.packetParser.on("403", () => {
        this.emit("403");
      });

      this.packetParser.on("401", (rawMessage) => {
        this.emit("401", rawMessage);
      });

      this.packetParser.on("auth_200", (rawMessage) => {
        this.emit("auth_200", rawMessage);
      });

      this.packetParser.on("SEND", (message) => {
        this.emit("SEND", message);
      });
    }
  }

  openSocket(protocol, host, port) {
    console.log("open socket", protocol, host, port);
    if (protocol === "ws") {
      console.log("connectionswew", this.connections);

      if (this.connections.size > 0) {
        this.endpoint.emit("socketOpened", protocol);
        return;
      }

      //native WebSocket API provided by the browser
      // const socket = new WebSocket(`ws://${host}:${port}`, "msrp");
     //const socket = new WebSocket(`ws://127.0.0.1:3457`, "msrp");

      const socket = new WebSocket("wss://websocket.payeda.net/ws3", "msrp");
      socket.onopen = () => {
        console.log(`Connected to ${host}:${port} using WebSocket`);
        console.log("connections after set", this.connections);
        this.connections.set(protocol, socket);

        console.log("connections array", this.connections);
        console.log("after", this.connections.size);

        this.endpoint.emit("socketOpened", protocol);
      };

      socket.onmessage = (event) => {
        let data = event.data;

        // Check if the data is a Blob
        if (data instanceof Blob) {
          data
            .text()
            .then((text) => {
              console.log("Received WebSocket data as Blob, converted to text:", text);
              try {
                this.packetParser.parse(text);
              } catch (err) {
                console.error("Failed to parse MSRP message:", err);
              }
            })
            .catch((err) => {
              console.error("Error reading Blob data:", err);
            });
        } else {
          console.log("Received WebSocket data:", data);
          try {
            // Pass the data to the message parser directly if it's already a string
            this.packetParser.parse(data);
          } catch (err) {
            console.error("Failed to parse MSRP message:", err);
          }
        }
      };

      socket.onerror = (err) => {
        console.error(`WebSocket connection error:`, err);
        this.emit("error", new Error(`WebSocket connection error unexpectedly`));
      };

      socket.onclose = () => {
        console.log(`WebSocket connection closed`);
        this.connections.delete(protocol);
        this.emit("error", new Error(`WebSocket connection error unexpectedly`));
      };
    } else {
      console.error("Unsupported protocol:", protocol);
    }
  }

  // TODO: delete this after tests
  // openConnection(protocol, host, port) {
  //   if (protocol === "ws") {
  //     console.log("connectionsarr", this.connections);
  //     console.log("before", this.connections.length);

  //     if (this.connections.length > 0) {
  //       this.emit("connected", protocol);
  //       return;
  //     }

  //     //native WebSocket API provided by the browser
  //     const socket = new WebSocket("ws://127.0.0.1:3457", "msrp");
  //     socket.onopen = () => {
  //       console.log(`Connected to ${host}:${port} using WebSocket`);
  //       this.connections.set(protocol, socket);

  //       console.log("connections after set", this.connections);

  //       this.emit("connected", protocol);
  //     };

  //     socket.onmessage = (event) => {
  //       let data = event.data;

  //       // Check if the data is a Blob
  //       if (data instanceof Blob) {
  //         data
  //           .text()
  //           .then((text) => {
  //             console.log("Received WebSocket data as Blob, converted to text:", text);
  //             try {
  //               this.packetParser.parse(text);
  //             } catch (err) {
  //               console.error("Failed to parse MSRP message:", err);
  //             }
  //           })
  //           .catch((err) => {
  //             console.error("Error reading Blob data:", err);
  //           });
  //       } else {
  //         console.log("Received WebSocket data:", data);
  //         try {
  //           // Pass the data to the message parser directly if it's already a string
  //           this.packetParser.parse(data);
  //         } catch (err) {
  //           console.error("Failed to parse MSRP message:", err);
  //         }
  //       }
  //     };

  //     socket.onerror = (err) => {
  //       console.error(`WebSocket connection error:`, err);
  //     };

  //     socket.onclose = () => {
  //       console.log(`WebSocket connection closed`);
  //       this.connections.delete(protocol);
  //     };
  //   } else {
  //     console.error("Unsupported protocol:", protocol);
  //   }
  // }

  sendMessage(protocol, message) {
    console.log("connectionManager :: send message function is called");
    const socket = this.connections.get(protocol);
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
      console.log("message sent successfully");
    } else {
      console.warn(`No active connection found for protocol ${protocol}`);
    }
  }

  closeConnection(protocol) {
    const socket = this.connections.get(protocol);
    if (socket) {
      socket.close();
      console.log(`${protocol} connection closed`);
      this.connections.delete(protocol);
    } else {
      console.warn(`No active connection found for protocol ${protocol}`);
    }
  }
}

export default ConnectionManager;
